<!-- 签单订单列表 -->
<template>
	<div>
		<el-card class="box-card">
			<el-form :inline="true">
				<el-form-item label="订单号/运单号">
					<el-input resize="none" type="textarea" :rows="6" placeholder="多个单号用回车分割"
						v-model="listQuery.search.order_number">
					</el-input>
				</el-form-item>
				<el-button type="danger" @click="toSign" icon="el-icon-aim">扫码签收</el-button>
				<el-button type="success" @click="toSignBatch" icon="el-icon-aim">批量签收</el-button>
			</el-form>
			<el-button type="primary" @click="keySearch"><i class="el-icon-search"></i> 搜索</el-button>
			<el-button type="primary" style="margin-left:30px;" plain @click="resetSearch"><i
					class="el-icon-search"></i>
				重置搜索</el-button>
		</el-card>
		<div style="margin-top:30px">
			<el-table v-loading="loading" :data="data_list" stripe style="width: 100%" size="small">
				<!-- <el-table-column prop="id" label="ID" width="60"></el-table-column> -->
				<el-table-column v-if="role_body == 'admin' || role_body == 'hhr'" prop="ck_uid_name" label="仓库" width="80"></el-table-column>
				<el-table-column v-if="role_body == 'admin' || role_body == 'hhr'" prop="uid_name" label="合作商" width="80"></el-table-column>
				<el-table-column prop="platform_init" label="平台" width="80">
					<template slot-scope="{row,$index}">
						<span>{{row.platform_init}}</span>
						<br>
						<span>{{row.country_init}}</span>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="country_init" label="国家" width="80"></el-table-column> -->
				<el-table-column prop="group_init" label="分组"></el-table-column>
				<el-table-column prop="send_type_init" label="发货类型" width="80"></el-table-column>
				<!-- <el-table-column prop="tn_number" label="运单号">
					<template slot-scope="{row,$index}">
						<span>{{row.tn_number}}</span>
					</template>
				</el-table-column> -->
				<el-table-column prop="shop_name" label="店铺名"></el-table-column>
				<!-- <el-table-column prop="address" label="订单地址"></el-table-column> -->
				<!-- <el-table-column prop="price" label="订单金额">
					<template slot-scope="{row,$index}">
						<span>{{row.price}}({{row.coin_name}}) / {{row.price_rmb}}</span>
					</template>
				</el-table-column> -->
				<!-- <el-table-column prop="currency_type_init" label="支付币种" width="80"></el-table-column> -->
				<!-- <el-table-column prop="commission_money" label="佣金" width="80"></el-table-column> -->
				<el-table-column prop="order_number" label="订单号/运单号" width="130">
					<template slot-scope="{row,$index}">
						<span>{{row.order_number}}</span>
						<br>
						<span>{{row.tn_number}}</span>
					</template>
				</el-table-column>
				<el-table-column v-if="sign_img_size == 1" prop="sign_img" label="签收截图">
					<template slot-scope="{row,$index}">
						<el-image v-if="row.sign_img" style="width: 100px; height: 100px"
							:src="row.sign_img" fit="fill" :preview-src-list="[row.sign_img]">
						</el-image>
					</template>
				</el-table-column>
				<el-table-column v-if="sign_img_size == 2" prop="sign_img" label="签收截图" width="400">
					<template slot-scope="{row,$index}">
						<el-image v-if="row.sign_img" style="width: 400px; height: 400px"
							:src="row.sign_img" fit="cover" :preview-src-list="[row.sign_img]">
						</el-image>
					</template>
				</el-table-column>
				<el-table-column prop="sign_remarks" label="签收备注"></el-table-column>
				<el-table-column prop="create_time" label="创建时间/签收时间" width="180">
					<template slot-scope="{row,$index}">
						<span>{{row.create_time}}</span>
						<br>
						<span>{{row.sign_time}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="price" label="原始金额 / 签收金额" width="180">
					<template slot-scope="{row,$index}">
						<span>{{row.price}}({{row.coin_name}})</span>
						<br>
						<span>{{row.sign_price}}({{row.coin_name}})</span>
					</template>
				</el-table-column>
				<el-table-column prop="state" label="状态" width="80">
					<template slot-scope="{row,$index}">
						<el-tag :type="row.state_color">{{row.state_init}}</el-tag>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="sign_price" label="签收金额" width="100">
					<template slot-scope="{row,$index}">
						<span>{{row.sign_price}}({{row.coin_name}})</span>
					</template>
				</el-table-column> -->
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.row"
				@pagination="getList" />

			<!-- 扫码签收 -->
			<el-dialog title="扫码签收" width="50%" :visible.sync="is_show_sign">
				<el-row>
					<el-col :span="12" :offset="6">
						<span style="color: red;"> 如扫码无反应，请确认鼠标焦点是否在该页面上!!!</span>
						<el-form :inline="true">
							<el-form-item label="运单号">
								<el-input ref='tn' placeholder="扫码或填写" v-model="scan_tn" clearable> </el-input>
							</el-form-item>
							<el-button type="primary" @click="getOrder">搜索</el-button>
						</el-form>
					</el-col>
				</el-row>
				<el-row v-if="order_data_show">
					<el-divider></el-divider>
					<el-col :span="12" :offset="6">
						<el-form :model="order_data" label-width="80px" label-position="left">
							<el-form-item label="订单号:">
								<span>{{order_data.order_number}}</span>
							</el-form-item>
							<el-form-item label="订单金额:">
								<span>{{order_data.price}} ({{order_data.coin_name}})</span>
							</el-form-item>
							<el-form-item label="实际金额:">
								<el-input-number :precision="2" :step="0.1" v-model="order_data.sign_price"></el-input-number> ({{order_data.coin_name}})
							</el-form-item>
							<el-form-item label="截图:">
								<el-col :span="12">
									<signImg @imgList="imgsImg" :img_num="1" :img_edit="order_data.sign_img"></signImg>
								</el-col>
							</el-form-item>
							<el-form-item label="签收备注:">
								<el-input v-model="order_data.sign_remarks" placeholder="请输入内容"></el-input>
							</el-form-item>
							<el-button :loading="this.$store.state.ajaxLoading" style="margin-left: 40px;" type="success" @click="signUp(order_data.id)">提交</el-button>
						</el-form>
					</el-col>
				</el-row>
				<span slot="footer" class="dialog-footer">
					<el-button @click="is_show_sign = false">返回</el-button>
				</span>
			</el-dialog>
			
			<!-- 扫码签收 - 批量 -->
			<el-dialog :close-on-click-modal="false" title="扫码签收 - 批量" width="95%" :visible.sync="is_show_sign_batch">
				<SignBatch :is_show_sign_batch="is_show_sign_batch" :admin_id="admin_id"></SignBatch>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import {
		orderSignList,
		getOrder,
		signUp
	} from '@/api/sign_admin'
	import request from '@/tool/request'
	import {
		parseTime,
		alertMsg
	} from '@/tool/index'
	import Qs from 'qs'
	import Pagination from '@/components/Pagination' // 基于分页的二级包装
	import signImg from '@/components/Jd/signImg.vue' // 上传图片组件
	import SignBatch from '@/components/Jd/signBatch.vue' // 批量签收组件
	export default {
		components: {
			Pagination,
			signImg,
			SignBatch
		},
		data() {
			return {
				total: 0, // 总条数
				listQuery: null,
				data_list: [], // 表格数据
				loading: true,
				group_list: [], // 所有分组
				platform_list: [], // 所有平台
				country_list: [], // 所有国家
				is_show_sign: false,
				scan_tn: '',
				order_data:{},
				order_data_show:false,
				role_body:'',
				is_show_sign_batch:false,
				sign_img_size:1, // 签收图片大小
				admin_id:0, // 管理员id
			};
		},
		filters: {
			parseTime,
		},
		created() {
			this.resetSearchData();
			this.getList();
			this.codeListen();
		},
		methods: {
			keySearch() { // 搜索
				// 隐藏功能，图片变大
				if(this.listQuery.search.order_number == '大'){
					this.sign_img_size = 2;
					this.listQuery.search.order_number = '';
					if(this.admin_id == 1 || this.admin_id == 9){
						alertMsg(this, '恭喜触发隐藏要素，你变得跟坤哥一样大了 (✪ω✪)', 'success');
					}
					return false;
				}
				this.listQuery.page = 1;
				this.getList()
			},
			resetSearch() { // 重置搜索
				this.resetSearchData()
				this.getList()
			},
			resetSearchData() { // 重置listQuery搜索数据
				this.listQuery = {
					page: 1,
					row: 10,
					search: {
						name: '',
					},
				}
			},
			getList() { // 获取列表数据
				this.loading = true;
				orderSignList(Qs.stringify(this.listQuery)).then(response => {
					let r = response.result;
					this.data_list = r.items;
					this.total = r.total;
					if (r.platform_list) {
						this.platform_list = r.platform_list;
					}
					if (r.country_list) {
						this.country_list = r.country_list;
					}
					if (r.group_list) {
						this.group_list = r.group_list;
					}
					if (r.role_body) {
						this.role_body = r.role_body;
					}
					if (r.admin_id) {
						this.admin_id = r.admin_id;
					}
					this.loading = false;
				})
			},
			// 扫码签收
			toSign() {
				this.is_show_sign = true;
				// 因为真实节点还没生成，所以必须使用this.$nextTick
				this.$nextTick(() => {
					this.$refs.tn.focus();
				})
			},
			// 获取到订单
			getOrder() {
				let post = {
					tn: this.scan_tn
				};
				getOrder(Qs.stringify(post)).then(response => {
					this.order_data = response.result;
					this.order_data_show = true;
					alertMsg(this, '订单信息获取成功', 'success');
				})
			},
			imgsImg(e) { // 用户图片调用组件时候的回调
				this.order_data.sign_img = e[0].url;
			},
			// 签收提交
			signUp(id){
				this.$store.commit('setAjaxLoading', true);
				let post = {
					id: id,
					sign_price:this.order_data.sign_price,
					sign_img:this.order_data.sign_img,
					sign_remarks:this.order_data.sign_remarks,
				};
				signUp(Qs.stringify(post)).then(response => {
					this.scan_tn = '';
					this.order_data = {};
					this.order_data_show = false;
					alertMsg(this, '签收成功', 'success');
					this.$refs.tn.focus();
				})
			},
			// 批量签收点击
			toSignBatch(){
				this.is_show_sign_batch = true;
			},
			// 监听扫码
			codeListen(){
				let code = "";
				let lastTime, nextTime;
				let lastCode, nextCode;
				document.onkeypress = (e) => {
					if (window.event) { // IE
						nextCode = e.keyCode;
					} else if (e.which) { // Netscape/Firefox/Opera
						nextCode = e.which;
					}
					if (nextCode === 13) {
						if (code.length < 3) return; // 手动输入的时间不会让code的长度大于2，所以这里只会对扫码枪有
			
						e.preventDefault();
						// 获取订单详情
						this.getOrder();
			
						code = '';
						lastCode = '';
						lastTime = '';
						return;
					}
					nextTime = new Date().getTime();
					if (!lastTime && !lastCode) {
						code += e.key;
					}
			
					if (lastCode && lastTime && nextTime - lastTime > 30) { // 当扫码前有keypress事件时,防止首字缺失
						code = e.key;
					} else if (lastCode && lastTime) {
						code += e.key;
					}
					lastCode = nextCode;
					lastTime = nextTime;
				}
			},
		}
	}
</script>
<style>
	textarea {
		font-family: Arial;
	}
</style>
